module.exports = __webpack_public_path__ + "static/img/shop4.4f8092f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop4.png
// module id = b/oH
// module chunks = 2